import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-black transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 uppercase tracking-widest",
  {
    variants: {
      variant: {
        default:
          "bg-[#00E676] text-[#0A0F1E] hover:bg-[#00E676]/90 shadow-[0_0_20px_rgba(0,230,118,0.2)]",
        outline:
          "border border-[#00E676] bg-transparent text-[#00E676] hover:bg-[#00E676]/10",
        secondary:
          "bg-[#111827] text-white border border-[#1F2937] hover:border-[#00E676]",
        ghost: "text-[#6B7280] hover:text-white hover:bg-white/5",
        link: "text-[#00E676] underline-offset-4 hover:underline",
        amber: "bg-[#F59E0B] text-[#0A0F1E] hover:bg-[#F59E0B]/90 font-black",
      },
      size: {
        default: "h-12 px-8 py-2",
        sm: "h-9 px-4 text-xs",
        lg: "h-14 px-10 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, style, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  
  // Enforce font family inline for maximum priority
  const forcedStyle = {
    fontFamily: "'JetBrains Mono', monospace",
    borderRadius: '0px',
    ...style
  }

  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      style={forcedStyle}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
